import { render, staticRenderFns } from "./CreateBrokeredSettlementDialog.vue?vue&type=template&id=3d6e6fac&"
import script from "./CreateBrokeredSettlementDialog.vue?vue&type=script&lang=js&"
export * from "./CreateBrokeredSettlementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCardTitle,VForm,VSelect})
